var __jsx = React.createElement;
import dynamic from 'next/dynamic';
import React from 'react';
import { ENVIRONMENT, isNonProdEnv } from '@webtv/env';
import { jsx as _jsx } from "react/jsx-runtime";
var QAConfigToolFlyoutContainer = dynamic(function () {
  return import('./QAConfigToolFlyout');
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak('./QAConfigToolFlyout')];
    }
  }
});

var QAConfigTool = function QAConfigTool() {
  return isNonProdEnv(ENVIRONMENT) ? /*#__PURE__*/_jsx(QAConfigToolFlyoutContainer, {}) : null;
};

export default QAConfigTool;